import * as React from "react"
import { Provider } from "react-redux"
import { createRoot } from "react-dom/client"

import OldUIContext from "../../olduicontext"
import { AppStore } from "../../store"

import ItemDetailField from "./components/ItemDetailField"
import { setItemId, fetchFields, setFeedbackKey } from "./slice"
import { IOldUIContext } from "../../global"

interface OldUIInit {
    start: (
        element: HTMLElement | undefined | null,
        itemId: number,
        fieldId: string,
        feedbackKey: string,
    ) => void
    refetchFields: () => void
}

function init(store: AppStore, oldUIContext: IOldUIContext): OldUIInit {
    const start = (
        element: HTMLElement | undefined | null,
        itemId: number,
        fieldId: string,
        feedbackKey: string,
    ): void => {
        if (!element) {
            throw new Error("Element should have value")
        }

        store.dispatch(setItemId(itemId))
        store.dispatch(setFeedbackKey({ fieldId, feedbackKey }))

        if (element) {
            const root = createRoot(element)
            root.render(
                <Provider store={store}>
                    <OldUIContext.Provider value={oldUIContext}>
                        <ItemDetailField fieldId={fieldId} />
                    </OldUIContext.Provider>
                </Provider>,
            )
        }
    }

    const refetchFields = (): void => {
        store.dispatch(fetchFields())
    }

    return {
        start,
        refetchFields,
    }
}

export default init
